import { CanaryBannerContainer } from 'src/components/canaryDeploymentNotice';
import { NavigateBlockerProvider } from 'src/components/navigateBlockerProvider';

import { LayoutProps } from './Layout.interface';
import { Content, ContentInner, StandardLayoutWrapper } from './Layout.styled';
import { Navbar } from './navbar';

export const StandardLayout: React.FC<LayoutProps> = (props) => {
  return (
    <StandardLayoutWrapper>
      <Navbar />
      <Content>
        <CanaryBannerContainer />
        <ContentInner>
          <NavigateBlockerProvider>{props.children}</NavigateBlockerProvider>
        </ContentInner>
      </Content>
    </StandardLayoutWrapper>
  );
};
